module.exports = __webpack_public_path__ + "zyro-ituwrc.png?fb67f00ef07ac84799e78bf22f408ca7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newsenviromental/zyro-ituwrc.png
// module id = 316
// module chunks = 0